import React, { Component } from 'react';
import Index from '../components/Screening/Queries/Index';
import WebpackerReact from 'webpacker-react';

class ScreeningQueries extends Component {
    render() {
        return <Index current_url={this.props.current_url} />;
    }
}

export default ScreeningQueries;
WebpackerReact.setup({ ScreeningQueries });
